export default __webpack_public_path__ + "static/media/0016.0ee4c904.png";